import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { useAuthStore } from '@/stores/auth'
import { message } from '@/api/message'

const baseURL = import.meta.env.VITE_API_BASE || '/api/v1'

export const http: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30000,
})

http.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const auth = useAuthStore.getState()
  if (auth.csrf) {
    config.headers['X-CSRF-Token'] = auth.csrf
  }
  return config
})

http.interceptors.response.use(
  (resp) => {
    const body = resp.data
    if (body && typeof body === 'object' && 'code' in body && 'data' in body) {
      return body.data
    }
    return body
  },
  (err) => {
    const status = err?.response?.status
    if (status === 401) {
      // silent: the router guard probes /me and redirects to login
      useAuthStore.setState({ profile: null })
    } else if (status === 403) {
      message.error('Permission denied')
    }
    return Promise.reject(err)
  },
)
